import { useState } from "react";
import { BaseModal } from "../../common/BaseModal";
import { ModalButtonGroup } from "../../common/ModalButtonGroup";

interface DeleteRecurringScheduleModalProps {
  isOpen: boolean;
  onClose: () => void;
  scheduleTitle: string;
  onConfirm: () => Promise<void>;
}

export function DeleteRecurringScheduleModal({
  isOpen,
  onClose,
  scheduleTitle,
  onConfirm,
}: DeleteRecurringScheduleModalProps) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm();
      onClose();
    } catch {
      // Error handling is done in parent component
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) onClose();
  };

  if (!isOpen) return null;

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Delete Recurring Schedule"
      size="small"
      loading={loading}
    >
      <div style={{ marginBottom: "20px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "12px",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#dc2626"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ flexShrink: 0 }}
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <span style={{ fontSize: "14px", fontWeight: 700, color: "#dc2626" }}>
            This action cannot be undone
          </span>
        </div>

        <div
          style={{
            backgroundColor: "#fef2f2",
            border: "1px solid #fecaca",
            borderRadius: "8px",
            padding: "14px 16px",
          }}
        >
          <p
            style={{ fontSize: "14px", color: "#111827", margin: "0 0 10px 0" }}
          >
            You are about to delete{" "}
            <span
              style={{
                fontWeight: 700,
                color: "#1e40af",
                backgroundColor: "#dbeafe",
                borderRadius: "4px",
                padding: "1px 6px",
              }}
            >
              {scheduleTitle}
            </span>
          </p>
          <ul
            style={{
              margin: 0,
              paddingLeft: "18px",
              fontSize: "13px",
              color: "#6b7280",
              lineHeight: "1.7",
            }}
          >
            <li>All upcoming job instances will be permanently deleted</li>
            <li>Past and completed jobs will not be affected</li>
          </ul>
        </div>
      </div>

      <ModalButtonGroup
        onCancel={handleClose}
        onSubmit={handleConfirm}
        submitLabel="Delete Schedule"
        cancelLabel="Cancel"
        isLoading={loading}
        loadingLabel="Deleting..."
        submitVariant="danger"
        submitType="button"
      />
    </BaseModal>
  );
}
